let Distribution = [
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:35:30Z",
    "file": "/v2/images/6900d461-3df0-4c80-985e-f3918288dddc/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "6900d461-3df0-4c80-985e-f3918288dddc",
    "size": 283299840,
    "self": "/v2/images/6900d461-3df0-4c80-985e-f3918288dddc",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Fedora-33-x86_64",
    "checksum": "f5f9bc6d803abf208903af0133afaa3a",
    "created_at": "2021-01-02T06:38:42Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "b6e51430e0ba456b9af8df6fc15f464b03625d0f8a8026487c7a42ac0a040932e5acabd92ec8afb39b93384536b27ea1c2f578f47c46fb6ab87cc61de06937b0",
    "distribution": "Fedora",
    "version": "33",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:35:46Z",
    "file": "/v2/images/517e98df-721d-43b4-9dd6-518839051f64/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "517e98df-721d-43b4-9dd6-518839051f64",
    "size": 302841856,
    "self": "/v2/images/517e98df-721d-43b4-9dd6-518839051f64",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Fedora-32-x86_64",
    "checksum": "9ba41708fdc7d21a829e3836242f56d6",
    "created_at": "2021-01-02T06:38:06Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "c0047c55111f36dd0b05df30c6acb822c725e82ae132d43ed6af6aae5921e834266faeb8249b02150d3ce86c6dd627d434a113148ea313a4e3bc8a924c17fd76",
    "distribution": "Fedora",
    "version": "32",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:35:56Z",
    "file": "/v2/images/b8abdb22-29dc-4ce6-8da2-b8830f493b2f/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "b8abdb22-29dc-4ce6-8da2-b8830f493b2f",
    "size": 355350528,
    "self": "/v2/images/b8abdb22-29dc-4ce6-8da2-b8830f493b2f",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Fedora-31-x86_64",
    "checksum": "726b5ea57013e6a71b1cddb25356cfe5",
    "created_at": "2021-01-02T06:37:51Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "5e8cad1d5a2d9bed835f20be1612c885a89ffb0d0e64b03911e37effc5968011830ee9cc62f7d6b1fb92b1b6b92b5cca3d0aed43618e4407287122e368b817ad",
    "distribution": "Fedora",
    "version": "31",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:33:50Z",
    "file": "/v2/images/228729cc-42ef-4482-a90b-a02f7360b828/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "228729cc-42ef-4482-a90b-a02f7360b828",
    "size": 332267520,
    "self": "/v2/images/228729cc-42ef-4482-a90b-a02f7360b828",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Fedora-30-x86_64",
    "checksum": "ffa3dd42fae539dcd8fe72d429bc677b",
    "created_at": "2021-01-02T06:37:36Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "d9f99d22a6b6ea1e8b93379dd2080f51a7ed6885aa7d4c2f2262ea1054935e02c47b45f9b56aa7f55e61d149d06f4ff6de03efde24f9d6774baf35f08c5e9d92",
    "distribution": "Fedora",
    "version": "30",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-25T12:04:15Z",
    "file": "/v2/images/63c21141-1296-4b15-be21-7c16e6bad047/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "63c21141-1296-4b15-be21-7c16e6bad047",
    "size": 224461312,
    "self": "/v2/images/63c21141-1296-4b15-be21-7c16e6bad047",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "openSUSE Leap-15.2-x86_64",
    "checksum": "b1972234c824cb987cf2679495b004ce",
    "created_at": "2021-01-02T06:41:01Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "65b82ba0ad2d79e7fdca6ca87c963696df855b0212696bd50b1551147cdb7c3e23f15ceea0c40c9ef7a69358ef510948c3bf30637758bb0e3fdf8071cb47f291",
    "distribution": "openSUSE Leap",
    "version": "15.2",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-25T12:03:45Z",
    "file": "/v2/images/fc0057a0-ebdc-4565-8652-821eed226eed/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "fc0057a0-ebdc-4565-8652-821eed226eed",
    "size": 223932416,
    "self": "/v2/images/fc0057a0-ebdc-4565-8652-821eed226eed",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "openSUSE Leap-15.1-x86_64",
    "checksum": "c0cc536f7cf52c2b10c55919837b532c",
    "created_at": "2021-01-02T06:41:17Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "537e9c3f4c6ed24a9e53919aa679a8488f0628358e5132bb365074125c039403cf1c7e712cc05656a11ab955ea568339da170f7f05d2ec35d8f4e33a1fa2572c",
    "distribution": "openSUSE Leap",
    "version": "15.1",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:33:27Z",
    "file": "/v2/images/54c16a31-73bc-42aa-bced-3abefc69a1ea/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "54c16a31-73bc-42aa-bced-3abefc69a1ea",
    "size": 534815744,
    "self": "/v2/images/54c16a31-73bc-42aa-bced-3abefc69a1ea",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Debian-10-x86_64",
    "checksum": "668af636273cccf3a5e886f13495c1bf",
    "created_at": "2021-01-02T06:39:11Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "d52536a54bb41a44afba04c8b85c5ad104792f1c8ea89d882026440ae8d9f68e67b1a0fd154f4936fba5c048265dc6d12985ce3dda5c56185a015f454df60b6b",
    "distribution": "Debian",
    "version": "10",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:33:39Z",
    "file": "/v2/images/90e8aa92-c6b2-4a5a-92ee-d608d655de72/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "90e8aa92-c6b2-4a5a-92ee-d608d655de72",
    "size": 609526784,
    "self": "/v2/images/90e8aa92-c6b2-4a5a-92ee-d608d655de72",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Debian-9-x86_64",
    "checksum": "fa3e0d6e1697325d3b235f6c4b843f7a",
    "created_at": "2021-01-02T06:39:33Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "1973a1fd240546cd90ea82872f593b5480603d8fd8a49f82a091446a7e8660e77fbf4fd302ebb1e8e04d7730379779696acf705aaa28d96a88fb0cad56ff8aaf",
    "distribution": "Debian",
    "version": "9",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:33:18Z",
    "file": "/v2/images/71ddc0ce-b765-4ea6-a3c3-9bcde2156772/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "71ddc0ce-b765-4ea6-a3c3-9bcde2156772",
    "size": 1165338624,
    "self": "/v2/images/71ddc0ce-b765-4ea6-a3c3-9bcde2156772",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "CentOS-8.2-x86_64",
    "checksum": "ec2bb3267e18fe074622b84eec72b5bb",
    "created_at": "2021-01-02T06:29:27Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "e4797ebee464003dfa46d7e55202cc2f0685724aa15cfb99f17cdc8673cf7ed7b4e6795788bda652d6d0f25f59396c209867fa90ad7aa697050456be6db5ae27",
    "distribution": "CentOS",
    "version": "8.2",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-01-07T05:33:05Z",
    "file": "/v2/images/4ce77327-2645-44d8-b9b1-ad1e377f5683/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "4ce77327-2645-44d8-b9b1-ad1e377f5683",
    "size": 858783744,
    "self": "/v2/images/4ce77327-2645-44d8-b9b1-ad1e377f5683",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "CentOS-7.8-x86_64",
    "checksum": "ef7f109590094e37c54aead73f3cdedc",
    "created_at": "2021-01-02T06:31:12Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "72a90b056215b7a4f216bd962082cceecfc7ea8e9a93b80f141d2a07f8d7890c735a19a30be0a7580f24897bc451c95750f39569c83205b642c1e60d43f92c93",
    "distribution": "CentOS",
    "version": "7.8",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:02:45Z",
    "file": "/v2/images/497af438-4b80-46fa-b355-d73ed7cbde38/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "497af438-4b80-46fa-b355-d73ed7cbde38",
    "size": 546308096,
    "self": "/v2/images/497af438-4b80-46fa-b355-d73ed7cbde38",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Ubuntu-20.04 LTS-x86_64",
    "checksum": "727566261b98ac1f8e060d7fa1360925",
    "created_at": "2020-11-23T08:37:03Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "48d65c8e0e261a13dce296099f7124b9f22c6be4420fc66b70854ecd5715a90a6c533f651e6403a53bc236bd16a792ad02ea505ce460862d30b6a228f520672c",
    "distribution": "Ubuntu",
    "version": "20.04 LTS",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:02:57Z",
    "file": "/v2/images/56444993-7a34-4f00-9f71-c5f0f1e74b70/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "56444993-7a34-4f00-9f71-c5f0f1e74b70",
    "size": 361234432,
    "self": "/v2/images/56444993-7a34-4f00-9f71-c5f0f1e74b70",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Ubuntu-18.04 LTS-x86_64",
    "checksum": "efadfda4941c589deccfd112c1410e2f",
    "created_at": "2020-11-23T08:36:41Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "c58b8609f09340015974dc41463d3d59591335518d3304442fe03e5bace3fc59b0f6fd075b9d6daac54d26c3da561dee38fc3d096316f7f066984fd2499e5043",
    "distribution": "Ubuntu",
    "version": "18.04 LTS",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:03:15Z",
    "file": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8",
    "size": 313196544,
    "self": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Ubuntu-16.04 LTS-x86_64",
    "checksum": "e3af673a2005d2f7fa04dca0ad8d5efe",
    "created_at": "2020-11-23T08:36:23Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "eafff28d578f734077d3f1ba00385ff57f9a4548bdd8029c78492a63c385f5d079a8db7971c805dca8054d74aa1407a4231ae96dfa0e67a3f72f441f43e2f678",
    "distribution": "Ubuntu",
    "version": "16.04 LTS",
    "instructionSet": "x86_64"
  },
  ,
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:03:15Z",
    "file": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "90869169-5c00-43c8-9520-86ee1f8db8f2",
    "size": 313196544,
    "self": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "AlmaLinux-8.0-x86_64",
    "checksum": "e3af673a2005d2f7fa04dca0ad8d5efe",
    "created_at": "2020-11-23T08:36:23Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "eafff28d578f734077d3f1ba00385ff57f9a4548bdd8029c78492a63c385f5d079a8db7971c805dca8054d74aa1407a4231ae96dfa0e67a3f72f441f43e2f678",
    "distribution": "AlmaLinux",
    "version": "8.0",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:03:15Z",
    "file": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "90869169-5c00-43c8-9520-86ee1f8dbds",
    "size": 313196544,
    "self": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Rocky Linux-8.5-x86_64",
    "checksum": "e3af673a2005d2f7fa04dca0ad8d5efe",
    "created_at": "2020-11-23T08:36:23Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "eafff28d578f734077d3f1ba00385ff57f9a4548bdd8029c78492a63c385f5d079a8db7971c805dca8054d74aa1407a4231ae96dfa0e67a3f72f441f43e2f678",
    "distribution": "Rocky Linux",
    "version": "8.5",
    "instructionSet": "x86_64"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2020-11-23T10:03:15Z",
    "file": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "90869169-5c00-43c8-9520-86ee1f8db8lk",
    "size": 313196544,
    "self": "/v2/images/b3b5f1d0-81fb-4066-8e7a-e4b36242e7d8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Rocky Linux-8.4-x86_64",
    "checksum": "e3af673a2005d2f7fa04dca0ad8d5efe",
    "created_at": "2020-11-23T08:36:23Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "eafff28d578f734077d3f1ba00385ff57f9a4548bdd8029c78492a63c385f5d079a8db7971c805dca8054d74aa1407a4231ae96dfa0e67a3f72f441f43e2f678",
    "distribution": "Rocky Linux",
    "version": "8.4",
    "instructionSet": "x86_64"
  }
];

export default Distribution;